import {
    attributeContainer,
    attributeIcon,
    messageText,
} from '../styles/InfoMessage'
import {AttributeProps} from './types'
import Highlight from 'components/Highlight'
import React from 'react'
import {styled} from '../../../../stitches/config'

const StyledText = styled('div', messageText)
const StyledTextJson = styled('div', messageText, {wordBreak: 'break-all'})
const StyledAttributeContainer = styled('div', attributeContainer)
const StyledIcon = styled('div', attributeIcon)

const Attribute = (props: AttributeProps & {renderAsMarkdown?: boolean}): React.ReactElement => {
    const {
        icon: Icon,
        json,
        text,
        type,
        renderAsMarkdown = false,
    } = props

    return (
        <StyledAttributeContainer>
            <StyledIcon type={type}>
                <Icon />
            </StyledIcon>
            {!json && renderAsMarkdown ?
                <StyledText><Highlight>{text}</Highlight></StyledText>
                :
                <StyledText>{text}</StyledText>}
            {!!json &&
                <StyledTextJson>{text}</StyledTextJson>}
        </StyledAttributeContainer>
    )
}

Attribute.defaultProps = {renderAsMarkdown: false}

export default Attribute
